import React, { useState,useEffect }  from "react";
import logo from "../image/logo.png"; // Update this path if needed
import { Container,Table } from "react-bootstrap";
import Footer from "./footer";
import DashboardNavbar from "./DashboardNavbar";
import {getData} from '../api/protectedApi'
import ReactPaginate from 'react-paginate';

const PoolChart = () => {
   const [poolData, setPoolData] = useState([]);
   const getPoolData = async(page = 0) => { 
         await getData("/user_pools")
           .then((res) => {  
               setPoolData(res.data.data) 
           }) .catch((err) => console.error("ee", err)); 
     }

     useEffect(() => {
        getPoolData()
      }, []);
  return (
    <div
      style={{ backgroundColor: "#141915", minHeight: "100vh", color: "#fff" }}
    >
      {/* Pool Chart Section */}
      <Container style={{ maxWidth: "900px" }}>
        {/* NAVBAR */}
        <DashboardNavbar />
        <h3 className="mb-4 text-white">Pool Chart</h3>

        <div
           style={{
            backgroundColor: "#2a352a",
            borderRadius: "12px",
            overflowX: "auto",
          }}
        >
          <Table responsive borderless className="m-0">
            <thead
              className="text-white"
              style={{ backgroundColor: "#2a352a" }}
            >
              <tr style={{ borderBottom: "1px solid rgba(255,255,255,0.1)" }}>
                <th>S No.</th>
                <th>Pool</th>
                <th>Upline</th>
                <th>Down Node</th>
                <th>Down Count</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {poolData.map((item, idx) => (
                <tr key={idx}>
                  <td  style={{ backgroundColor: "#2a352a", color: "#fff",  }}  >
                    { parseInt( 1 + idx)}  
                  </td>
                  <td style={{ backgroundColor: "#2a352a",  color: "#fff",  }} >
                    {item.pool_id}
                  </td>
                  <td style={{ backgroundColor: "#2a352a", color: "#fff",  }} >
                    {item.upline_id}
                  </td>
                  <td style={{ backgroundColor: "#2a352a", color: "#fff",  }} >
                    {item.down_node}
                  </td>
                  <td style={{ backgroundColor: "#2a352a", color: "#fff",  }} >
                    {item.down_count}
                  </td>
                  <td style={{  backgroundColor: "#2a352a", color: "#fff",  }} >
                    {item.created_at}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </Container>

      {/* FOOTER */}
      <Footer />
    </div>
  );
};

export default PoolChart;
